import { lazy } from "react";

const Dashboard = lazy(() => import("../pages/Dashboard/index.js"));
const FilterPage = lazy(() => import("../pages/FilterPage/index.js"));
const propertyDetails = lazy(() => import("../pages/PropertyDetails/index.js"));
const ForgotPassword = lazy(() => import("../pages/authentication/ForgotPassword.js"));
const PhoneAuth = lazy(() => import("../pages/authentication/PhoneAuth.js"));
const Register = lazy(() => import("../pages/authentication/Registeration.js"));
const savedProperties = lazy(() => import("../pages/SavedProperties/index.js"));
const userProfile = lazy(() => import("../pages/userProfile/index.js"));
const EditProfile = lazy(() => import("../pages/userProfile/components/EditProfile.js"));
const TermsandConditions = lazy(() => import("../pages/userProfile/components/Terms.js"));
const Help = lazy(() => import("../pages/userProfile/components/Help.js"));
const PrivacyPolicy = lazy(() => import("../pages/userProfile/components/PrivacyPolicy.js"));
const AdminDashboard = lazy(() => import("../pages/Admin/Dashboard/index.js"));
const ListYourProperty = lazy(() => import("../pages/Admin/Addlisting/index.js"));
const Settings = lazy(() => import("../pages/Admin/Profile/index.js"));
const MyListing = lazy(() => import("../pages/Admin/Listing/index.js"));
const ViewList = lazy(() => import("../pages/Admin/viewlisting/index.js"));

const EditProperty = lazy(() => import("../pages/Admin/EditListing/index.js"));




const CoreRoutes = [
  {
    path: "home",
    component: Dashboard,
    name: 'Home'
  },
  { path: "dashboard", component: AdminDashboard, name: "Admin Dashboard", protected: true, roles: ["admin", "agent"] },

  {
    path: "dashboard/profile",
    component: Settings,
    name: 'Admin Profile',
    protected: true, roles: ["admin", "agent"]
  },
  {
    path: "dashboard/viewlist",
    component: ViewList,
    name: 'Manage Listings',
    protected: true, roles: ["admin", "agent"]
  },
  {
    path: "dashboard/createlist",
    component: ListYourProperty,
    name: 'Create Listing',
    protected: true, roles: ["admin", "agent"]
  },

  {
    path: "dashboard/editlist/:id",
    component: EditProperty,
    name: 'Edit Listing',
    protected: true, roles: ["admin", "agent"]
  },
  // Regular User Routes
  {
    path: "home/filterPage",
    component: FilterPage,
    name: 'Filter Page'
  },
  {
    path: "home/property/:id",
    component: propertyDetails,
    name: "Property Details"
  },



  {
    path: "home/forgotPassword",
    component: ForgotPassword,
    name: "Forgot Password"
  },
  {
    path: "home/mobileAuth",
    component: PhoneAuth,
    name: "Phone Auth"
  },
  {
    path: "signup",
    component: Register,
    name: "Register"
  },
  {
    path: "home/saved",
    component: savedProperties,
    name: "Saved Properties"
  },
  {
    path: "home/profile",
    component: userProfile,
    name: "User Profile"
  },
  {
    path: "home/profile/editProfile",
    component: EditProfile,
    name: "Edit Profile"
  },
  {
    path: "home/profile/terms-n-conditions",
    component: TermsandConditions,
    name: "Terms and Conditions"
  },
  {
    path: "home/profile/help",
    component: Help,
    name: "Help"
  },
  {
    path: "home/profile/privacypolicy",
    component: PrivacyPolicy,
    name: "Privacy Policy"
  }
];

export default CoreRoutes;